import React from "react";
import PropTypes from "prop-types";

function SectionSubheading({ className, subheading, ...rest }) {
    return (
        <div {...rest}>
            <h3 className={"section-subheading  " + className} tabIndex={0}>
                {subheading}
            </h3>
        </div>
    );
}

SectionSubheading.propTypes = {
    className: PropTypes.string,
    subheading: PropTypes.string
}

export default SectionSubheading;
